var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_vm._v("\n  Wing Leung is a passionate javascript engineer with a DevOps mentality and a\n  creative thinker who loves experimenting with new web technologies.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }